import BaseSliderManager from "../../../../src/managers/BaseSliderManager/BaseSliderManager";
import { SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL } from "../types/Config";
import { SliderGenProps } from "../../../../src/types/Interface";
import { EventBus, EnumEventBus } from "./EventBus";


const SliderGen: SliderGenProps[] = [
  {
    head: "circumference angle",
    colors: {
      bgColor: 0x21D4FE,
      barColor: 0x000000,
      buttonColor: 0x21D4FE
    },
    onUpdate: (v: number) => EventBus.emit(EnumEventBus.setCircumPoint, v - 100)
  },
  {
    head: "central angle",
    colors: {
      bgColor: 0xFC99C4,
      barColor: 0x000000,
      buttonColor: 0xFC99C4
    },
    onUpdate: (v: number) => EventBus.emit(EnumEventBus.setCentralAngle, v - 100)
  },
  {
    head: "rotate the circle",
    colors: {
      bgColor: 0xBFBFBF,
      barColor: 0x000000,
      buttonColor: 0x000000
    },
    onUpdate: (v: number) => EventBus.emit(EnumEventBus.setRotateCircle, v - 100)
  }
]


export default class SliderManager extends BaseSliderManager {
  constructor() {
    super(SliderGen, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL)
  }
}